<div class="cure-sheets">
  <div class="cure-sheets-header">
    <h2 class="cure-sheets-title">{{ 'CureSheetsTitle' | t }}</h2>
  </div>

  <div class="cure-sheets-loading" *ngIf="isLoading">{{ 'CureSheetsLoading' | t }}</div>

  <ng-container *ngIf="!isLoading">
    <!-- LIST FAILURES. Each says what the user can do; none shows a server
         string. The 403 in particular is "your account is not provisioned",
         which is a different sentence from "access denied". -->
    <div class="cure-sheets-state" *ngIf="listFailure === 'notProvisioned'">
      <p class="cure-sheets-state-title">{{ 'CureSheetsNotProvisionedTitle' | t }}</p>
      <p class="cure-sheets-state-detail">{{ 'CureSheetsNotProvisionedDetail' | t }}</p>
    </div>

    <div class="cure-sheets-state" *ngIf="listFailure === 'server' || listFailure === 'unauthenticated'">
      <p class="cure-sheets-state-title">{{ 'CureSheetsListErrorTitle' | t }}</p>
      <p class="cure-sheets-state-detail">{{ 'CureSheetsListErrorDetail' | t }}</p>
      <button type="button" class="cure-sheets-retry" (click)="load()">{{ 'CureSheetsRetry' | t }}</button>
    </div>

    <ng-container *ngIf="listFailure === 'none'">
      <!-- NOT ENTITLED — the company-level gate. Names the feature and says it is
           part of a subscription; it does not imply the screen is broken. -->
      <div class="cure-sheets-state" *ngIf="!isEntitled">
        <p class="cure-sheets-state-title">{{ 'CureSheetsNotEntitledTitle' | t }}</p>
        <p class="cure-sheets-state-detail">{{ 'CureSheetsNotEntitledDetail' | t }}</p>
      </div>

      <ng-container *ngIf="isEntitled">
        <!-- ENTITLED, NOTHING EXPOSED. A successful empty answer, with the action
             that changes it, rather than "something went wrong". -->
        <div class="cure-sheets-state" *ngIf="isEmpty">
          <p class="cure-sheets-state-title">{{ 'CureSheetsEmptyTitle' | t }}</p>
          <p class="cure-sheets-state-detail">{{ 'CureSheetsEmptyDetail' | t }}</p>
        </div>

        <div class="cure-sheets-body" *ngIf="!isEmpty">
          <div class="cure-sheets-list">
            <app-project-grid
              [model]="gridModel"
              [view]="gridView"
              flexibleColumnId="brandName"
              [selectedKey]="selectedKey"
              (sortToggle)="onGridSort($event)"
              (filterChange)="onGridFilter($event)"
              (selectProject)="selectSheet($any($event))"
            ></app-project-grid>
          </div>

          <div class="cure-sheets-viewer">
            <div class="cure-sheets-state" *ngIf="!selectedSheet">
              <p class="cure-sheets-state-detail">{{ 'CureSheetsSelectPrompt' | t }}</p>
            </div>

            <ng-container *ngIf="selectedSheet">
              <div class="cure-sheets-viewer-head">
                <span class="cure-sheets-viewer-name">{{ displayName(selectedSheet) }}</span>
                <span class="cure-sheets-viewer-version">
                  {{ 'CureSheetsVersionLabel' | t }} {{ selectedSheet.version }}
                </span>
              </div>

              <div class="cure-sheets-loading" *ngIf="isPdfLoading">{{ 'CureSheetsPdfLoading' | t }}</div>

              <!-- OUR OWN COPY, NEVER THE SERVER'S. A denial returns
                   HYB-CURESHEET-UNAVAILABLE with the words "this device" — the
                   browser and device routes share one helper — and a console user
                   has no device. Denials are also uniform across withdrawn /
                   unexposed / unapproved so the library cannot be enumerated, so
                   this deliberately does not guess which one it was. -->
              <div class="cure-sheets-state" *ngIf="!isPdfLoading && pdfFailure === 'unavailable'">
                <p class="cure-sheets-state-title">{{ 'CureSheetsPdfUnavailableTitle' | t }}</p>
                <p class="cure-sheets-state-detail">{{ 'CureSheetsPdfUnavailableDetail' | t }}</p>
              </div>

              <div class="cure-sheets-state" *ngIf="!isPdfLoading && (pdfFailure === 'server' || pdfFailure === 'notProvisioned' || pdfFailure === 'unauthenticated')">
                <p class="cure-sheets-state-title">{{ 'CureSheetsPdfErrorTitle' | t }}</p>
                <p class="cure-sheets-state-detail">{{ 'CureSheetsPdfErrorDetail' | t }}</p>
                <button type="button" class="cure-sheets-retry" (click)="selectSheet(selectedSheet)">
                  {{ 'CureSheetsRetry' | t }}
                </button>
              </div>

              <!-- Fetched as a blob through HttpClient and rendered from an object
                   URL. A src pointed at the API would carry no bearer and 401. -->
              <iframe
                *ngIf="!isPdfLoading && pdfFailure === 'none' && pdfUrl"
                class="cure-sheets-pdf"
                [src]="pdfUrl"
                [title]="displayName(selectedSheet)"
              ></iframe>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
